import React, { useEffect, useLayoutEffect, useState, useRef } from "react";
import { Grid, InputAdornment, TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { connect } from "react-redux";
import {
  START_GET_ACTIVITY_LOG,
  START_GET_FIELD_STAFF_LIST,
} from "../../../Actions/ActivityAction";
import moment from "moment";
import { ReactComponent as SearchIcon } from "Assets/Icons/SearchIcon.svg";
import _ from "underscore";
import { getClearObject } from "../../../utils/generalUtils";
import { useIntersection } from "../../../Hooks/customHooks";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import ClearIcon from "@mui/icons-material/Clear";
import "../../../Sass/Common.scss";

import PrimaryIcon from "Components/Common/PrimaryIcon";
import { START_PAYMENT_LIST } from "../../../Actions/HomeAction";
import PaymentLogTable from "./PaymentLogTable";
import InvoiceDailoag from "./InvoiceDailoag";
const StaffAutoComplete = React.lazy(() =>
  import("../../../Components/Patients/StaffAutoComplete")
);

const useStyle = makeStyles((theme) => ({
  rsActivityHeader: {
    backgroundColor: " #333",
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
    padding: " 6px 6px",

    // marginBottom: "20px",
    // display: "flex",
    // justifyContent: "end",
    "&>button": {
      marginLeft: "0",
      fontSize: "14px",
      height: "37px !important",
    },
    "&>div": {
      marginTop: "0px",
      width: "200px",
      marginRight: "20px",
      height: "37px !important",
      "&>div": {
        marginTop: "0px",
        height: "37px !important",
        "&>div": {
          height: "37px !important",
        },
      },
    },
    "&>div:nth-child(3)": {
      background: "transparent",
      boxShadow: "none",
    },
  },
  autoCompleteBox: {
    background: theme.palette.white.main,
    boxShadow: "0px 0px 10px rgb(90 104 114 / 10%)",
    borderRadius: "4px",
    marginRight: "20px !important",
    minWidth: "280px !important",
    "& .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
  },
  removeBorderColor: {
    "&>div": {
      "&>fieldset": {
        borderColor: "transparent !important",
      },
      "&>div": {
        "&>fieldset": {
          borderColor: "transparent !important",
        },
      },
    },
  },
}));

const PaymentListMain = (props) => {
  const classes = useStyle();
  const { paymentListMain, getPaymentAction, getSearchStaffListAction } = props;
  const [setTarget, entry] = useIntersection({ threshold: 0.1 });
  const [searchValue, setSearchValue] = useState("");
  const [selectedStaffData, setSelectedStaffData] = useState([]);
  const staffListFlag = true;
  const defaultColumnOrderBy = "asc";
  const [columnSortingOrder, setColumnSortingOrder] = useState({
    orderBy: "",
    sortBy: "",
  });
  const [filterFromDate, setFilterFromDate] = useState(null);
  const [filterFromDateError, setFilterFromDateError] = useState("");
  const [filterToDate, setFilterToDate] = useState(null);
  const [filterToDateError, setFilterToDateError] = useState("");
  const [openToDate, setOpenToDate] = useState(false);
  const [openFromDate, setOpenFromDate] = useState(false);
  const [daysFilter, setDaysFilter] = useState("7_days");
  const [callDate, setCallDate] = useState(false);
  const [openInvoice, setOpenInvoice] = useState(false);
  const [link, setLink] = useState("");
  /** get api call */
  useLayoutEffect(() => {
    getSearchStaffListAction({ offset: 0 });
  }, []);

  /** Get api call main function */
  const searchActivityLogAction = (
    params = {},
    tempDaysFilter = "",
    loadmore = true
  ) => {
    let payload = {
      offset: 0,
      q: searchValue,
      limit: 25,
      order_by: columnSortingOrder.orderBy,
      sort_by: columnSortingOrder.sortBy.toUpperCase(),
      staff_id: Object.keys(selectedStaffData),
    };

    if (filterFromDate !== null && filterToDate !== null) {
      payload.date = {
        from:
          filterFromDate != null
            ? moment(filterFromDate).format("YYYY-MM-DD")
            : null,
        to:
          filterToDate != null
            ? moment(filterToDate).format("YYYY-MM-DD")
            : null,
      };
    }
    if (filterFromDate !== null && filterToDate == null) {
      payload.date = {
        from:
          filterFromDate != null
            ? moment(filterFromDate).format("YYYY-MM-DD")
            : null,
      };
    }

    if (
      filterFromDate == null &&
      filterToDate == null &&
      tempDaysFilter !== ""
    ) {
      var today = new Date();
      let tempDate = new Date(today);
      let fromDate = null;
      if (tempDaysFilter === "7_days") {
        fromDate = tempDate.setDate(today.getDate() - 7);
      }
      if (tempDaysFilter === "month") {
        fromDate = tempDate.setMonth(today.getMonth() - 1);
      }
      if (tempDaysFilter === "6_months") {
        fromDate = tempDate.setMonth(today.getMonth() - 6);
      }
      if (tempDaysFilter === "year") {
        fromDate = tempDate.setFullYear(today.getFullYear() - 1);
      }
      if (tempDaysFilter === "all") {
        fromDate = tempDate.setDate(today.getDate() - 7);
      }
      if (tempDaysFilter === "all") {
        payload.all_record = true;
      } else {
        payload.date = {
          from: moment(fromDate).format("YYYY-MM-DD"),
          to: moment(new Date()).format("YYYY-MM-DD"),
        };
      }
    }

    payload = {
      ...payload,
      ...params,
    };
    getPaymentAction(getClearObject(payload), loadmore);
  };

  //   /** Search activity log debounce Function */
  //   const searchActivityLogDebounce = useRef(
  //     _.debounce((searchString, otherStateValues = {}) => {
  //       searchActivityLogAction({
  //         ...(searchString && {
  //           q: searchString,
  //         }),
  //         ...otherStateValues,
  //       });
  //     }, 500)
  //   );

  /** for lazy loading */
  //   useEffect(() => {
  //     if (entry.isIntersecting) {
  //       if (
  //         activityList?.data?.list?.length !== activityList?.data?.filterd_record
  //       ) {
  //         searchActivityLogAction(
  //           {
  //             offset: activityList?.data?.list?.length,
  //             limit: 25,
  //             order_by: columnSortingOrder.orderBy,
  //             sort_by: columnSortingOrder.sortBy.toUpperCase(),
  //           }
  //           // daysFilter,
  //           // true
  //         );
  //       }
  //     }
  //   }, [entry]);

  /** Search activity log action */
  //   const handleActivityLogSearchAction = (newValue) => {
  //     setSearchValue(newValue);
  //     searchActivityLogDebounce.current(newValue, {});
  //   };

  /** handle Surgery Change */
  //   const handleStaffFilterAction = (value) => {
  //     setSelectedStaffData(value);
  //     searchActivityLogAction({
  //       staff_id: Object.keys(value),
  //     });
  //   };

  /** Detect column order changes */
  //   useEffect(() => {
  //     if (
  //       columnSortingOrder?.orderBy !== "" ||
  //       columnSortingOrder?.sortBy !== ""
  //     ) {
  //       searchActivityLogAction();
  //     }
  //   }, [columnSortingOrder]);

  //   /** handle date filter  */
  //   const handleDateFilterAction = (date, type) => {
  //     let tempDate = new Date(date);
  //     if (type === "from_date" && tempDate !== "Invalid Date") {
  //       setFilterFromDate(date ? tempDate : null);
  //       if ((tempDate <= filterToDate || filterToDate == null) && date !== null) {
  //         setFilterToDateError("");
  //         setFilterFromDateError("");
  //       } else {
  //         /** update error message */
  //         if (filterToDate !== null || date == null)
  //           setFilterFromDateError("From date should be less than to date");
  //       }
  //     } else {
  //       if (date !== null && type === "from_date") {
  //         setFilterFromDateError("Please enter valid date");
  //       }
  //     }

  //     if (type === "to_date" && tempDate !== "Invalid Date") {
  //       setFilterToDate(date ? tempDate : null);
  //       if (tempDate >= filterFromDate && filterFromDate != null) {
  //         setFilterFromDateError("");
  //         setFilterToDateError("");
  //       } else {
  //         /** update error message*/
  //         if (date !== null) {
  //           setFilterToDateError("To date should be greater than from date");
  //         }
  //       }
  //     } else {
  //       if (date !== null && type === "to_date") {
  //         setFilterToDateError("Please enter valid date");
  //       }
  //     }
  //   };

  //   /** handle filter from  date changes  */
  //   useEffect(() => {
  //     if (filterFromDate !== "Invalid Date" && callDate) {
  //       if (filterFromDate > new Date()) {
  //         setFilterFromDateError("From date should be less than to future date");
  //       }
  //       if (filterFromDate && filterFromDate <= new Date()) {
  //         setFilterFromDateError("");
  //         /** filter activity log */

  //         searchActivityLogAction({
  //           date: {
  //             from:
  //               filterFromDate !== null
  //                 ? moment(filterFromDate).format("YYYY-MM-DD")
  //                 : null,
  //           },
  //         });
  //       }

  //       if (
  //         filterFromDate &&
  //         filterFromDate <= new Date() &&
  //         filterToDate !== null
  //       ) {
  //         setFilterFromDateError("");

  //         /** filter activity log */
  //         searchActivityLogAction({
  //           date: {
  //             from:
  //               filterFromDate !== null
  //                 ? moment(filterFromDate).format("YYYY-MM-DD")
  //                 : null,
  //             to: moment(filterToDate).format("YYYY-MM-DD"),
  //           },
  //         });
  //       }
  //       if (filterFromDate == null) {
  //         setFilterFromDateError("");
  //         setFilterToDateError("");
  //         searchActivityLogAction({});
  //       }
  //     }
  //   }, [filterFromDate]);

  //   /** handle filter to  date changes  */
  //   useEffect(() => {
  //     if (filterToDate !== "Invalid Date" && callDate) {
  //       if (filterToDate > new Date()) {
  //         setFilterToDateError("To date should be less than to future date");
  //       }
  //       if (
  //         filterToDate &&
  //         filterToDate <= new Date() &&
  //         filterToDate >= filterFromDate &&
  //         filterFromDate !== null
  //       ) {
  //         setFilterToDateError("");
  //         /** filter activity log */
  //         searchActivityLogAction({
  //           date: {
  //             from:
  //               filterFromDate !== null
  //                 ? moment(filterFromDate).format("YYYY-MM-DD")
  //                 : null,
  //             to: moment(filterToDate).format("YYYY-MM-DD"),
  //           },
  //         });
  //       }
  //       if (filterToDate == null && filterFromDate != null) {
  //         if (filterToDate == null) {
  //           setFilterFromDateError("");
  //           setFilterToDateError("");
  //           searchActivityLogAction({});
  //         } else {
  //           /** filter activity log */
  //           searchActivityLogAction({
  //             date: {
  //               from:
  //                 filterFromDate !== null
  //                   ? moment(filterFromDate).format("YYYY-MM-DD")
  //                   : null,
  //             },
  //           });
  //         }
  //       }
  //       // if (filterToDate == null) {
  //       //   setFilterFromDateError("");
  //       //   setFilterToDateError("");
  //       //   searchActivityLogAction({});
  //       // }
  //     }
  //   }, [filterToDate]);

  useEffect(() => {
    searchActivityLogAction({});
    setCallDate(true);
  }, []);

  return (
    <Grid>
      {/* <Grid className={classes.rsActivityHeader}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            className={classes.removeBorderColor}
            open={openFromDate}
            onClose={() => setOpenFromDate(false)}
            disableFuture
            label="From date"
            inputFormat="DD-MM-YYYY"
            value={filterFromDate}
            onChange={(newDate) => {
              handleDateFilterAction(newDate, "from_date");
            }}
            renderInput={(params) => (
              <TextField
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
                size="small"
                name="order_date"
                {...params}
                error={filterFromDateError !== ""}
                helperText={filterFromDateError}
                InputProps={{
                  endAdornment: (
                    <>
                      {filterFromDate !== null && (
                        <InputAdornment
                          position="end"
                          onClick={() =>
                            handleDateFilterAction(null, "from_date")
                          }
                          className="cursor-pointer"
                        >
                          <PrimaryIcon width="20px" icon={ClearIcon} />
                        </InputAdornment>
                      )}
                      <InputAdornment
                        position="end"
                        onClick={() => setOpenFromDate(true)}
                        className="cursor-pointer"
                      >
                        <PrimaryIcon width="20px" icon={InsertInvitationIcon} />
                      </InputAdornment>
                    </>
                  ),
                }}
              />
            )}
          />
        </LocalizationProvider>

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            className={classes.removeBorderColor}
            open={openToDate}
            onClose={() => setOpenToDate(false)}
            disableFuture
            label="To date"
            inputFormat="DD-MM-YYYY"
            value={filterToDate}
            onChange={(newDate) => {
              handleDateFilterAction(newDate, "to_date");
            }}
            renderInput={(params) => (
              <TextField
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
                size="small"
                name="order_date"
                {...params}
                error={filterToDateError !== ""}
                helperText={filterToDateError}
                InputProps={{
                  endAdornment: (
                    <>
                      {filterToDate !== null && (
                        <InputAdornment
                          position="end"
                          onClick={() =>
                            handleDateFilterAction(null, "to_date")
                          }
                          className="cursor-pointer"
                        >
                          <PrimaryIcon width="20px" icon={ClearIcon} />
                        </InputAdornment>
                      )}
                      <InputAdornment
                        position="end"
                        onClick={() => setOpenToDate(true)}
                        className="cursor-pointer"
                      >
                        <PrimaryIcon width="20px" icon={InsertInvitationIcon} />
                      </InputAdornment>
                    </>
                  ),
                }}
              />
            )}
          />
        </LocalizationProvider>
        <StaffAutoComplete
          fullWidth
          multiple
          maxValue={1}
          surgeryListFlag={staffListFlag}
          className={classes.autoCompleteBox}
          value={selectedStaffData}
          handleChange={(value) => handleStaffFilterAction(value)}
          renderInput={(params) => <TextField {...params} label="Staffs" />}
        />
        <TextField
          withPadding={true}
          medium
          secondary
          placeholder="Search..."
          value={searchValue}
          onChange={(e) => {
            handleActivityLogSearchAction(e?.target?.value);
          }}
          InputProps={{
            endAdornment: (
              <>
                <InputAdornment position="end">
                  <PrimaryIcon width="20px" icon={SearchIcon} />
                </InputAdornment>
              </>
            ),
          }}
        />
      </Grid> */}
      <PaymentLogTable
        columnSortingOrder={columnSortingOrder}
        defaultColumnOrderBy={defaultColumnOrderBy}
        setColumnSortingOrder={setColumnSortingOrder}
        activityList={paymentListMain}
        setTarget={setTarget}
        link={link}
        setLink={setLink}
        openInvoice={openInvoice}
        setOpenInvoice={setOpenInvoice}
      />
      <InvoiceDailoag
        open={openInvoice}
        setOpen={setOpenInvoice}
        link={link}
        title="Invoice"
      />
    </Grid>
  );
};
const mapStateToProps = (state) => ({
  paymentListMain: state.home.paymentListMain,
});

const mapDispatchToProps = (dispatch) => ({
  getPaymentAction: (payload, loadmore) =>
    dispatch({ type: START_PAYMENT_LIST, payload, loadmore }),
  getSearchStaffListAction: (payload) =>
    dispatch({ type: START_GET_FIELD_STAFF_LIST, payload }),
});
export default connect(mapStateToProps, mapDispatchToProps)(PaymentListMain);
